import { ReactElement } from 'react';

import { Stack } from '@mui/material';

import { ContainerView, SubTitleText, TitleText } from '~/views/customer/PricingPlans/components';

export const NoAccessToPricing = (): ReactElement => (
  <ContainerView>
    <Stack alignItems="center" textAlign="center" gap={1.5} maxWidth={360}>
      <TitleText>Select a plan</TitleText>
      <SubTitleText>
        You don&apos;t have permission to manage plans. Contact a workspace admin to change your plan.
      </SubTitleText>
    </Stack>
  </ContainerView>
);
